import styles from './Masonry.css';
import Masonry from 'masonry-layout';

export default ($el: Element) => {
	if ($el instanceof HTMLElement) {
		const $gridSizer = $el.querySelector(`article:not(.${styles.isSpanningTwoColumns})`)
			?? $el.querySelector('article');

		if ($gridSizer) {
			$gridSizer.setAttribute('data-is-gridsizer', '1');

			const masonry = new Masonry($el, {
				itemSelector: 'article',
				columnWidth: '[data-is-gridsizer="1"]',
			});

			const resizeObserver = new ResizeObserver(() => {
				if (masonry.layout) {
					masonry.layout();
				}
			});

			$el.querySelectorAll('article').forEach($node =>
				resizeObserver.observe($node)
			);
		}
	}
}
